import React from 'react';
import {Sentry} from '@gogame/components';
import Form from './Form';

export const withForm =
  ({
    mapPropsToValues = ({ initialValues }) => initialValues || {},
    handleSubmit: configHandleSubmit,
    ...options
  } = {}) =>
  (BaseComponent) =>
    React.forwardRef((props, ref) => {
      const {
        onSubmit,
        validationSchema,
        enableReinitialize,
        enableReinitializeEqual,
        active,
        children,
        initialNormalized,
        normalizeEffect,
        ...mixedProps
      } = {
        ...options,
        ...props,
      };

      const handleSubmit = async (values, actions, meta) => {
        return (configHandleSubmit || onSubmit)(
          values,
          {
            ...actions,
            props,
          },
          meta
        );
      };

      return (
        <Sentry.FormErrorBoundary>
          <Form
            active={active}
            onSubmit={handleSubmit}
            initialValues={mapPropsToValues(props)}
            initialNormalized={initialNormalized}
            validationSchema={validationSchema}
            enableReinitialize={enableReinitialize}
            enableReinitializeEqual={enableReinitializeEqual}
            ref={ref}
            normalizeEffect={normalizeEffect}
          >
            {(formProps) => {
              return (
                <BaseComponent {...mixedProps} {...formProps}>
                  {children}
                </BaseComponent>
              );
            }}
          </Form>
        </Sentry.FormErrorBoundary>
      );
    });

export default withForm;
